import React from 'react';
import {SearchResultItemType} from "../../sections/navigation-menu/@type";
import {EntityType} from "../../../../core/gd/const/item";
import NavigationMenuItemPortfolio from "../../../menu/menu-items/portfolio/menu-item-portfolio";
import ProjectCollectionModel from "../../../../core/model2/project-collection/project-collection-model";
import NavigationMenuItemCustomView from "../../../menu/menu-items/custom-view/menu-item-custom-view";
import {NavigationSectionType} from "../../../../core/model2/navigation/@const";

type Props = {
    menuItem: SearchResultItemType
}

export default function MenuSearch_HomeViewResult(props: Props) {

    if(!props.menuItem.view) return null

    const navigationSection = gd.navigationStructure.get(NavigationSectionType.HOME)


    switch (props.menuItem.view.entityType) {
        case EntityType.PORTFOLIO:
           return <NavigationMenuItemPortfolio portfolio            = {props.menuItem.view as ProjectCollectionModel}
                                               navigationSection    ={navigationSection} />


        case EntityType.CUSTOM_VIEW:
        default:
            return <NavigationMenuItemCustomView viewId             = {props.menuItem.view.id}
                                                 navigationSection  = {navigationSection} />
    }
}
